import moment from 'moment';

export function formatDatetoString(text: Date | undefined): string {
    return moment(text).format('D/M/YYYY');
}
